export default __webpack_public_path__ + "static/media/093-chevron.64ca3b6e.png";